import keyMirror from "keymirror";

export const ListManagerCalendarConstants = {
    ActionTypes: keyMirror({
        SAVE_USER_EVENT_FAVOURITE: null,
    })
}

export const CalendarType = {
    AI_EVENT: 'AiEvent',
    PANARAY_EVENT: 'PanarayEvent',
    NONE: 'None',
};

export const DataItemId = {
    ERN_DUE_DATE: 4622,
    DIV_EX_DATE: 520,
    FUTURE_DATE: 4623,
};